export enum RouteVehicleTypeEnum {
    car = 'CAR',
    motorcycle = 'MOTORCYCLE',
    truck = 'TRUCK',
    scooter = 'SCOOTER',
    bicycle = 'BICYCLE',
    other = 'OTHER'
};